import {translationResultGet} from "../../modules/translate";
import {getAverageData} from "../../modules/result";

export function getFromData(language){
    switch (language) {
        case "trad" : return{
                title: "測試結果",
                type: {
                    R: "實際型",
                    I: "探究型",
                    A: "藝術型",
                    S: "社交型",
                    E: "企業型",
                    C: "常規型",
                },
                mark: "分數",
                rankpopTitle: "分數詳情",
                rankpop1:"活動: ",
                rankpop2:"技能: ",
                rankpop3:"職業: ",
                rankpop4:"自我評估",
                rankpop5:"第一部分: ",
                rankpop6:"第二部分: ",
                ranktips:"醒目提示",
                radartitle: "職業性向分佈圖",
                resultBtnDream: "我的夢想職業",
                resultBtnSuggest: "我的推薦職業",
                resultBtnQA: "我要發問！",
                pieChartTitle: "的男女比例",
                pieChartIndexF: "女",
                pieChartIndexM: "男",
                bulletAvg: "平均分",
                bulletMark:"我的分數",
                btnPrint: "列印測試結果",
                btnPdf: "下載PDF",
                btnEmail: "發送電郵",
                bulletTitle:"我在哪？",
                btnFinish: "完成"

            }
        }
}

export async function getTypeList(language) {
  // console.log(language)
  let type = []
  let typeR = await translationResultGet("type.R");
  let typeI = await translationResultGet("type.I");
  let typeA = await translationResultGet("type.A");
  let typeS = await translationResultGet("type.S");
  let typeE = await translationResultGet("type.E");
  let typeC = await translationResultGet("type.C");
  type = [typeR[language],typeI[language],typeA[language],typeS[language],typeE[language],typeC[language]]
  // console.log(type);
  
  // translationResultGet("type.R").then((data)=>type.push(data[language])).then(()=> console.log(type))
 return type
}


export function getRadarOption(language) {
  return getTypeList(language).then((typeList) => {
    return {
      chart: {
          height: '100%',
          type: 'radar',
          id: "result",
      },
      labels: typeList, //case language
      xaxis: {
          categories: typeList, //case language
          labels: {
              show: true,
              style: {
                  colors: ["#5D5D65","#5D5D65","#5D5D65","#5D5D65","#5D5D65","#5D5D65"],
                  fontSize: "13px",
                  fontFamily: "Source Sans Pro, Semibold",
              }
          }
      },
      yaxis: {
          show: false,
          max:60,
          min:0,
          tickAmount:5,
      },
      fill: {
          opacity: 0.25,
          colors: ["#DB724C"]
      },
      stroke: {
          show: true,
          width: 2,
          colors: ["#DB724C"],
          dashArray: 0
      },
      markers: {
          size: 3,
          colors: ["#FFFFFF"],
          strokeColors: ["#DB724C"],
          strokeWidth: 2,
          strokeOpacity: 0.9,
      },
      dataLabels: {
          enabled: false,
          textAnchor: "end",
          offsetX: 12,
          offsetY: 5,
          background: {
              enabled: false,
          },
          style: {
              colors: ["#312A24"],
              fontFamily: "Source Sans Pro, Semibold",
          }
      }
  }
  });
    
}

 export async function getPieData(language, apiData, resultData){
    
    //Initial Value
    var manCount = Math.floor(Math.random() * (20) ) + 40;
    var femaleCount = 100 - manCount;

    if (apiData == null) {
      apiData = {};
      apiData.RMalePercentage = 25;
      apiData.IMalePercentage = 25;
      apiData.AMalePercentage = 25;
      apiData.SMalePercentage = 25;
      apiData.EMalePercentage = 25;
      apiData.CMalePercentage = 25;
    } else {
      if (resultData != null && resultData.ranking != null) {
        if (resultData.ranking [0][0] === 'R') {
           manCount = apiData.RMalePercentage*100;
           femaleCount = 100-manCount;
        } else if (resultData.ranking [0][0] === 'I') {
          manCount = apiData.IMalePercentage*100;
          femaleCount = 100-manCount;
        } else if (resultData.ranking [0][0] === 'A') {
          manCount = apiData.AMalePercentage*100;
          femaleCount = 100-manCount;
        } else if (resultData.ranking [0][0] === 'S') {
          manCount = apiData.SMalePercentage*100;
          femaleCount = 100-manCount;
        } else if (resultData.ranking [0][0] === 'E') {
          manCount = apiData.EMalePercentage*100;
          femaleCount = 100-manCount;
        } else if (resultData.ranking [0][0] === 'C') {
          manCount = apiData.CMalePercentage*100;
          femaleCount = 100-manCount;
        }
      }
    }

    manCount = Math.round(manCount * 100) / 100
    femaleCount = Math.round(femaleCount * 100) / 100

    // var manCount = apiData.RMalePercentage*100;
    // var femaleCount = 100 - manCount;

    let labelM = await translationResultGet("result.M")
    let labelF = await translationResultGet("result.F")

    
    return[
      {
        "id": "男",
        "label": labelM[language],
        "value": manCount,
        "color": "#546FE0"
      },
      {
        "id": "女",
        "label": labelF[language],
        "value": femaleCount,
        "color": "#D454E0"
      },
    ]
}

export async function getBulletAverageData(){
  let  data = await getAverageData();
  return data;
}

export function getPieLegend(){
    return[
        {
            anchor: 'bottom',
            direction: 'row',
            justify: false,
            translateX: 0,
            translateY: 56,
            itemsSpacing: 0,
            itemWidth: 100,
            itemHeight: 18,
            itemTextColor: '#969696',
            itemDirection: 'left-to-right',
            itemOpacity: 1,
            symbolSize: 18,
            symbolShape: 'circle',
            effects: [
                {
                    on: 'hover',
                    style: {
                        itemTextColor: '#000'
                    }
                }
            ]
        }
    ]
}


export function getBulletData(data,type,apiData){

    if (apiData == null) {
      apiData = {};
      apiData.averageRcore = 25;
      apiData.averageIcore = 25;
      apiData.averageAcore = 25;
      apiData.averageScore = 25;
      apiData.averageEcore = 25;
      apiData.averageCcore = 25;
    }

    var maxScore = 55;
    return[
        {
          "id": type[0],
          "ranges": [
            maxScore
          ],
          "measures": [
            data.totalScore.R
          ],
          "markers": [
            apiData.averageRcore
          ]
        },
        {
            "id": type[1],
            "ranges": [
              maxScore
            ],
            "measures": [
              data.totalScore.I
            ],
            "markers": [
              apiData.averageCcore
            ]
          },
          {
            "id": type[2],
            "ranges": [
              maxScore
            ],
            "measures": [
              data.totalScore.A
            ],
            "markers": [
              apiData.averageAcore
            ]
          },
          {
            "id": type[3],
            "ranges": [
              maxScore
            ],
            "measures": [
              data.totalScore.S
            ],
            "markers": [
              apiData.averageScore
            ]
          },
          {
            "id": type[4],
            "ranges": [
              maxScore
            ],
            "measures": [
              data.totalScore.E
            ],
            "markers": [
              apiData.averageEcore
            ]
          },
          {
            "id": type[5],
            "ranges": [
              maxScore
            ],
            "measures": [
              data.totalScore.C
            ],
            "markers": [
              apiData.averageCcore
            ]
          },
      ]
}
